import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Game, GameStatuses, OvertimeTypes } from '@mtgame/core';
import { SEASON_QUERY_PARAM, TOURNAMENT_QUERY_PARAM } from '@config/routing-map';

@Component({
  selector: 'mtg-game-header',
  templateUrl: './game-header.component.html',
  styleUrls: ['./game-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameHeaderComponent {
  @Input()
  game: Game;
  @Input()
  teamRoute: string[];
  @Input()
  competitorTeamRoute: string[];
  gameStatuses = GameStatuses;

  get queryParams() {
    return {};
    /*
    return {
      [SEASON_QUERY_PARAM]: this.game.tournament.seasonId,
      [TOURNAMENT_QUERY_PARAM]: this.game.tournament.id,
    };*/
  }

  isHockeyOvertime(period: number): boolean {
    return period === this.game.hockeyGameConfig.periodsCount + 1 &&
      [OvertimeTypes.to_first_goal_and_bullitts, OvertimeTypes.to_first_goal].indexOf(this.game.hockeyGameConfig.overtimeType) > -1;
  }

  isHockeyShootouts(period: number): boolean {
    return (period === this.game.hockeyGameConfig.periodsCount + 1 && this.game.hockeyGameConfig.overtimeType === OvertimeTypes.bullitts) ||
      (period > this.game.hockeyGameConfig.periodsCount + 1);
  }
}
